import {ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromPotential from './potential.reducer';


export interface PotentialsState {
  potentials: fromPotential.PotentialState;
}

export const reducers: ActionReducerMap<PotentialsState> = {
  potentials: fromPotential.reducer,
};

export const reducer: ActionReducer<PotentialsState> = combineReducers(reducers);

export const getPotentialsState = createFeatureSelector<PotentialsState>('potentialsFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/reducers/index.ts